import { LOC_STORAGE_OAUTH_KEY } from 'shared/constants/web';
import { isValidJsonStr } from 'shared/helpers';


const webAdaptor = {
  get() {
    const val = window.localStorage.getItem(LOC_STORAGE_OAUTH_KEY);

    // Something's fucky, shouldn't happen, just throw it out.
    if (!isValidJsonStr(val)) {
      this.remove();
      return null;
    }

    return JSON.parse(val);
  },

  set(obj) {
    const val = JSON.stringify(obj);
    return window.localStorage.setItem(LOC_STORAGE_OAUTH_KEY, val);
  },

  remove() {
    return window.localStorage.removeItem(LOC_STORAGE_OAUTH_KEY);
  },
};


class OAuthStore {
  constructor() {
    if (window) {
      this.adaptor = webAdaptor;
    } else {
      // Placeholder for other runtime env, like ios or android etc..
      this.adaptor = null;
    }
  }

  get(platform) {
    const obj = this.adaptor.get() || {};

    if (!platform) {
      return obj;
    }

    return obj[platform];
  }

  set(platform, oauthUser) {
    const obj = this.adaptor.get() || {};
    obj[platform] = oauthUser;
    return this.adaptor.set(obj);
  }

  remove(platform) {
    const obj = this.adaptor.get() || {};
    delete obj[platform];

    return this.adaptor.set(obj);
  }

  removeAll() {
    return this.adaptor.remove();
  }
}


export default new OAuthStore();



// WEBPACK FOOTER //
// ./src/shared/helpers/oauthStore.js